import { SelectionItem } from './common';

export enum ConversationType {
  Direct = 1,
  Group = 2,
  Broadcast = 3,
}

export enum MessageStatus {
  Active = 1,
  Deleted = 2,
}

export enum MessageReference {
  None = 0,
  Join = 1,
  Leave = 2,
  Removed = 3,
  ReferenceDeleted = 4,
  UserDeleted = 5,
  NotAccessible = 6,
}

export interface AbstractConversationElement {
  conversationId: number;
  createDate: number;
  authorId: number;
  authorName: string;
  authorShortName: string;
  authorSubtype?: number;
  authorImageDefined: boolean;
  authorDeleted?: boolean;
}

export interface MessageRecipient extends SelectionItem {
  status: MessageStatus;
}

export interface ConversationRecipient extends SelectionItem {
  owner: boolean;
  status?: number;
  presentFrom?: number;
  presentTo?: number;
}

export interface Conversation extends AbstractConversationElement {
  read: boolean;
  title: string;
  type: number;
  messages: Message[];
  recipients: ConversationRecipient[];
  unreadMessages: number;
  lastMessageDate: number;
  updateDate: number;
  totalMessages: number;
}

export interface ConversationListElement {
  read: boolean;
  recipientShortName: string;
  conversationId: number;
  title: string;
  type: number;
  recipientId: number;
  recipientDisplayName: string;
  recipientImageDefined: boolean;
  unreadMessages: number;
  lastMessageDate: number;
  updateDate: number;
}

export interface Message extends AbstractConversationElement {
  messageId: number;
  message: string;
  status: MessageStatus;
  recipients?: MessageRecipient[];
  size?: number;
  contentType?: string;
  format?: string;
  reference?: number;
  fileName?: string;
  secView?: boolean;
  secViewPending?: boolean;
  secViewError?: number;
  read?: boolean;
  broadcastReference?: number;
  broadcast?: boolean;
}
